import { render, staticRenderFns } from "./SavedProjects.vue?vue&type=template&id=354cec9f&"
import script from "./SavedProjects.vue?vue&type=script&lang=js&"
export * from "./SavedProjects.vue?vue&type=script&lang=js&"
import style0 from "./SavedProjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports